/** Safe in-app return paths only (blocks open redirects) */
export function isSafeAppReturnUrl(url: string | null | undefined): url is string {
  if (!url) return false;
  if (!url.startsWith('/')) return false;
  if (url.startsWith('//')) return false;
  if (url.includes('://')) return false;
  return true;
}
